// @ts-nocheck
/**
 * Best Sellers Carousel Controller
 */
function initBestSellers(section) {
  if (!section) return;

  /* ==========================================================
     TRACK
  ========================================================== */

  var track = section.querySelector(
    '[data-best-sellers-track]'
  );


  if (!track) {

    return;

  }


  /* ==========================================================
     ORIGINAL PRODUCTS
  ========================================================== */

  var originalCards = Array.prototype.slice.call(

    track.querySelectorAll(
      '[data-original-card]'
    )

  );


  /*
    Need at least 2 products for a carousel.
  */

  if (originalCards.length < 2) {

    return;

  }


  /* ==========================================================
     SETTINGS
  ========================================================== */

  var AUTOPLAY_DELAY = 3000;

  var autoplayTimer = null;

  var isPaused = false;

  var isAdjusting = false;


  /* ==========================================================
     DUPLICATE PRODUCTS

     Example:

     ORIGINAL:

     1  2  3  4

     AFTER CLONING:

     1  2  3  4 | 1  2  3  4

     We move forward through the cloned set.

     When we reach the clone set, we silently move
     the scroll position back by exactly one set width.

     Visually it looks like:

     1 → 2 → 3 → 4 → 1 → 2 → 3 → 4 → ...

     There is no visible reverse.
  ========================================================== */

  originalCards.forEach(function (card) {

    var clone = card.cloneNode(true);


    /*
      Mark clone.

      This also prevents the script from cloning
      the clones again.
    */

    clone.removeAttribute(
      'data-original-card'
    );

    clone.setAttribute(
      'data-carousel-clone',
      'true'
    );


    /*
      Remove Shopify editor attributes from clone
      so the clone does not interfere with Theme Editor.
    */

    clone.removeAttribute(
      'data-shopify-editor-block'
    );


    track.appendChild(clone);

  });


  /* ==========================================================
     GET GAP
  ========================================================== */

  function getGap() {

    var styles =
      window.getComputedStyle(track);


    var gap =
      parseFloat(styles.columnGap);


    if (!gap) {

      gap =
        parseFloat(styles.gap);

    }


    if (isNaN(gap)) {

      gap = 0;

    }


    return gap;

  }


  /* ==========================================================
     GET CARD WIDTH
  ========================================================== */

  function getCardWidth() {

    var card =
      track.querySelector(
        '.best-sellers__card'
      );


    if (!card) {

      return 0;

    }


    return card.getBoundingClientRect().width;

  }


  /* ==========================================================
     GET STEP

     One product width + gap.
  ========================================================== */

  function getStep() {

    return (
      getCardWidth() +
      getGap()
    );

  }


  /* ==========================================================
     GET ORIGINAL SET WIDTH
  ========================================================== */

  function getOriginalSetWidth() {

    return (
      getStep() *
      originalCards.length
    );

  }


  /* ==========================================================
     MOVE FORWARD
  ========================================================== */

  function moveForward() {

    if (isAdjusting) {

      return;

    }


    var step =
      getStep();


    if (!step) {

      return;

    }


    /*
      ALWAYS moves forward.

      There is NO "scroll to 0" here.
    */

    track.scrollBy({

      left: step,

      behavior: 'smooth'

    });

  }


  /* ==========================================================
     MOVE BACKWARD - MANUAL ARROW ONLY
  ========================================================== */

  function moveBackward() {

    if (isAdjusting) {

      return;

    }


    var step =
      getStep();


    if (!step) {

      return;

    }


    /*
      Manual previous button is allowed to move
      backward.

      Autoplay NEVER calls this function.
    */

    if (track.scrollLeft <= 2) {

      var originalWidth =
        getOriginalSetWidth();


      /*
        Start from the equivalent position
        in the cloned set.
      */

      track.style.scrollBehavior = 'auto';


      track.scrollLeft =
        originalWidth;


      requestAnimationFrame(function () {

        track.style.scrollBehavior = '';

        track.scrollBy({

          left: -step,

          behavior: 'smooth'

        });

      });

    } else {

      track.scrollBy({

        left: -step,

        behavior: 'smooth'

      });

    }

  }


  /* ==========================================================
     INFINITE LOOP

     This is the important part.

     We NEVER animate backwards.

     When the first complete product set has passed,
     we silently shift the scroll position by exactly
     one set width.

     Because the second set contains identical products,
     the user sees no jump.
  ========================================================== */

  function checkInfiniteLoop() {

    if (isAdjusting) {

      return;

    }


    var originalWidth =
      getOriginalSetWidth();


    if (!originalWidth) {

      return;

    }


    if (
      track.scrollLeft >=
      originalWidth
    ) {

      isAdjusting = true;


      var currentPosition =
        track.scrollLeft;


      /*
        Turn smooth scrolling OFF temporarily.
      */

      track.style.scrollBehavior =
        'auto';


      /*
        Move the scroll position back
        by exactly one original set.

        Example:

        Position 4 → Position 0
        BUT visually the products are identical.

        Therefore the user sees:

        4 → 1

        instead of:

        4 → backwards → 1
      */

      track.scrollLeft =
        currentPosition -
        originalWidth;


      /*
        Wait one browser frame,
        then restore smooth scrolling.
      */

      requestAnimationFrame(function () {

        track.style.scrollBehavior =
          'smooth';


        requestAnimationFrame(function () {

          isAdjusting = false;

        });

      });

    }

  }


  /* ==========================================================
     SCROLL LISTENER
  ========================================================== */

  track.addEventListener(

    'scroll',

    checkInfiniteLoop,

    {
      passive: true
    }

  );


  /* ==========================================================
     AUTOPLAY
  ========================================================== */

  function startAutoplay() {

    stopAutoplay();


    if (isPaused) {

      return;

    }


    autoplayTimer = setInterval(

      function () {

        /*
          IMPORTANT:

          Autoplay only calls moveForward().

          It NEVER calls moveBackward().
        */

        moveForward();

      },

      AUTOPLAY_DELAY

    );

  }


  /* ==========================================================
     STOP AUTOPLAY
  ========================================================== */

  function stopAutoplay() {

    if (autoplayTimer) {

      clearInterval(
        autoplayTimer
      );

      autoplayTimer = null;

    }

  }


  /* ==========================================================
     NEXT BUTTON
  ========================================================== */

  var nextButton =
    section.querySelector(
      '[data-carousel-next]'
    );


  if (nextButton) {

    nextButton.addEventListener(
      'click',
      function () {

        moveForward();

        /*
          Reset the 3-second timer after manual click.
        */

        startAutoplay();

      }
    );

  }


  /* ==========================================================
     PREVIOUS BUTTON
  ========================================================== */

  var prevButton =
    section.querySelector(
      '[data-carousel-prev]'
    );


  if (prevButton) {

    prevButton.addEventListener(
      'click',
      function () {

        moveBackward();

        /*
          Reset the 3-second timer.
        */

        startAutoplay();

      }
    );

  }


  /* ==========================================================
     PAUSE ON HOVER
  ========================================================== */

  track.addEventListener(

    'mouseenter',

    function () {

      isPaused = true;

      stopAutoplay();

    }

  );


  track.addEventListener(

    'mouseleave',

    function () {

      isPaused = false;

      startAutoplay();

    }

  );


  /* ==========================================================
     TOUCH SWIPE
  ========================================================== */

  var touchStartX = 0;

  var touchStartY = 0;


  track.addEventListener(

    'touchstart',

    function (event) {

      if (
        !event.touches ||
        !event.touches.length
      ) {

        return;

      }


      touchStartX =
        event.touches[0].clientX;


      touchStartY =
        event.touches[0].clientY;


      stopAutoplay();

    },

    {
      passive: true
    }

  );


  track.addEventListener(

    'touchend',

    function (event) {

      if (
        !event.changedTouches ||
        !event.changedTouches.length
      ) {

        return;

      }


      var touchEndX =
        event.changedTouches[0].clientX;


      var touchEndY =
        event.changedTouches[0].clientY;


      var differenceX =
        touchStartX -
        touchEndX;


      var differenceY =
        touchStartY -
        touchEndY;


      /*
        Only treat it as a horizontal swipe
        if horizontal movement is greater.
      */

      if (
        Math.abs(differenceX) >
        Math.abs(differenceY)
      ) {

        if (
          Math.abs(differenceX) > 40
        ) {

          if (differenceX > 0) {

            /*
              Swipe LEFT = next
            */

            moveForward();

          } else {

            /*
              Swipe RIGHT = previous
            */

            moveBackward();

          }

        }

      }


      startAutoplay();

    },

    {
      passive: true
    }

  );


  /* ==========================================================
     KEYBOARD ACCESSIBILITY
  ========================================================== */

  track.addEventListener(

    'keydown',

    function (event) {

      if (
        event.key === 'ArrowRight'
      ) {

        event.preventDefault();

        moveForward();

        startAutoplay();

      }


      if (
        event.key === 'ArrowLeft'
      ) {

        event.preventDefault();

        moveBackward();

        startAutoplay();

      }

    }

  );


  /* ==========================================================
     RESIZE

     Recalculate after browser resize.
  ========================================================== */

  var resizeTimer = null;


  window.addEventListener(

    'resize',

    function () {

      clearTimeout(
        resizeTimer
      );


      resizeTimer =
        setTimeout(

          function () {

            checkInfiniteLoop();

          },

          250

        );

    }

  );


  /* ==========================================================
     SHOPIFY THEME EDITOR

     Restart after section reload.
  ========================================================== */

  document.addEventListener(

    'shopify:section:load',

    function (event) {

      if (
        event.detail &&
        event.detail.sectionId ===
          section.dataset.sectionId
      ) {

        /*
          Shopify will reload the section,
          so no action is required here.
        */

      }

    }

  );


  /* ==========================================================
     START
  ========================================================== */

  startAutoplay();
}

function initAllBestSellers() {
  document.querySelectorAll('.best-sellers').forEach(initBestSellers);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAllBestSellers);
} else {
  initAllBestSellers();
}

document.addEventListener('shopify:section:load', function (event) {
  const target = event.target?.querySelector?.('.best-sellers');
  if (target) initBestSellers(target);
});

